export default "__VITE_ASSET__f5467949__"